import React from "react";
import { Dialog } from "@headlessui/react";

interface ProgressModalProps {
  message?: string;
}

export default function ProgressModal({ message = "Processing..." }: ProgressModalProps) {
  return (
    <div>
      <div>
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full mb-4">
          <svg
            className="animate-spin h-8 w-8 text-main-purple"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title as="h3" className="text-lg font-semibold leading-6 text-gray-900">
            {message}
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm text-gray-500">Please wait while we process your request...</p>
          </div>
        </div>
      </div>
    </div>
  );
}
